import React, { useEffect, useRef, useState } from "react";
import {
  Deleteinsurance,
  Editinsurencedetails,
  FetchEligibilityCheck,
  GetInsurance,
  GETinsurencedetails,
  Postinsurencedetails,
  uploadImage,
} from "../../api/helper";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { ShowToast } from "../../helpers/ToastService";
import DeleteModal from "../AgencyFlow/Components/DeleteModal";

const validationSchema = Yup.object().shape({
  PlanType: Yup.string().required("Plan Type is required"),
  PlanName: Yup.string().required("Plan Name is required"),
  PolicyNumber: Yup.string().required("Policy Number is required"),
  PhoneNumber: Yup.string().required("Phone Number is required"),

  GroupNumber: Yup.string()
    .matches(/^\d+$/, "Group Number should contain only numbers")
    .notRequired(),
  CopayAmount: Yup.string()
    .matches(/^\$?\d+(\.\d{2})?$/, "Invalid amount (e.g., $0.00 or 0.00)")
    .notRequired(),
  DeductibleAmount: Yup.string()
    .matches(/^\$?\d+(\.\d{2})?$/, "Invalid amount (e.g., $0.00 or 0.00)")
    .notRequired(),
  PatientRelationship: Yup.string()
    .required("Relationship is required")
    .notOneOf(["Select Option"], "Please select a valid relationship"),
  frontcard: Yup.string().required("Front of card is required"),
  backcard: Yup.string().required("Back of card is required"),
  // insured_name: Yup.string().when('relationship', {
  //     is: (value) => value !== 'self' && value !== '',
  //     then: Yup.string().required('Field is required'),
  //     otherwise: Yup.string().notRequired(),
  //   }),
  // insured_id: Yup.string().when([], {
  //   is: () => relationship !== "self" && relationship !== "",
  //   then: Yup.string().required("Insured ID is required"),
  // }),
  // ZipCode: Yup.string().when([], {
  //   is: () => relationship !== "self" && relationship !== "",
  //   then: Yup.string().required("Zip Code is required"),
  // }),
  // StreetAddress: Yup.string().when([], {
  //   is: () => relationship !== "self" && relationship !== "",
  //   then: Yup.string().required("Street Address is required"),
  // }),
  // Apt: Yup.string().when([], {
  //   is: () => relationship !== "self" && relationship !== "",
  //   then: Yup.string().required("Apt is required"),
  // }),
  // City: Yup.string().when([], {
  //   is: () => relationship !== "self" && relationship !== "",
  //   then: Yup.string().required("City is required"),
  // }),
  // dob: Yup.date().when([], {
  //   is: () => relationship !== "self" && relationship !== "",
  //   then: Yup.date().required("DOB is required"),
  // }),
  // ssn: Yup.string().when([], {
  //   is: () => relationship !== "self" && relationship !== "",
  //   then: Yup.string().required("SSN is required"),
  // }),
  // gender: Yup.string().when([], {
  //   is: () => relationship !== "self" && relationship !== "",
  //   then: Yup.string().required("Gender is required"),
  // }),
  // Telephone: Yup.string().when([], {
  //   is: () => relationship !== "self" && relationship !== "",
  //   then: Yup.string().required("Telephone is required"),
  // }),
  // state: Yup.string().when([], {
  //   is: () => relationship !== "self" && relationship !== "",
  //   then: Yup.string().required("State is required"),
  // }),
});
const InsuranceDetailsVerify = ({ info }) => {
  const [relationship, setRelationship] = useState("self");
  const [insurancedata, setinsurancedata] = useState([]);
  const [modalopen, setmodalopen] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [insurance, setInsurance] = useState([]);
  const [modal, setmodal] = useState(false);
  const [confirmdeletemodal, setconfirmdeletemodal] = useState(false);
  const [deleteId, setdeleteId] = useState(null);
  const [editingData, setEditingData] = useState(null);
  const frontImageInputRef = useRef(null);
  const backImageInputRef = useRef(null);
  const [image, setImages] = useState(null);
  const [setbackimage, setsetbackimage] = useState(null);

  // console.log(info?.insuranceId?._id,"info=-=-==-")
  const {
    register,
    handleSubmit,
    reset,
    trigger,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const Getinsurancedata = async () => {
    const response = await GetInsurance(`?id=${info?.agencyId?._id}`);
    setInsurance(response?.data?.data);
  };
  useEffect(() => {
    Getinsurancedata();
  }, []);
  const onSubmit = async (data) => {
    console.log("Submitting data:", data);
    // Your existing logic...
  };

  const onError = (errors) => {
    console.error("Validation errors:", errors);
  };

  const handleEditSubmit = async (data) => {
    data.agencyId = info?.agencyId?._id;
    data.patientId = info?._id;
    data.frontcard = image;
    data.backcard = setbackimage;

    try {
      const response = await Editinsurencedetails(data, editingData._id);
      ShowToast(response?.data?.message);
      Fetchinsurencedetails();
      closemodal();
      reset();
      setEditingData(null);
    } catch (error) {
      console.error(error);
    }
  };

  const closemodal = () => {
    reset({
      PlanType: "",
      PlanName: "",
      PolicyNumber: "",
      PhoneNumber: "",
      GroupNumber: "",
      CopayAmount: "",
      DeductibleAmount: "",
      PatientRelationship: "",
      insured_name: "",
      insured_id: "",
      streetAddress: "",
      city: "",
      state: "",
      zipCode: "",
      dob: "",
    });
    setEditingData(null);
    setmodalopen(false);
  };
  const Fetchinsurencedetails = async () => {
    try {
      const response = await GETinsurencedetails(
        info?.agencyId?._id,
        info?._id
      );
      setinsurancedata(response?.data?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    Fetchinsurencedetails();
  }, []);

  const handleRemove = (id) => {
    setdeleteId(id);
    setconfirmdeletemodal(true);
  };

  const confirmDelete = async () => {
    setconfirmdeletemodal(false);
    try {
      const response = await Deleteinsurance(deleteId);
      ShowToast(response?.data?.message);
      Fetchinsurencedetails();
    } catch (error) {
      console.log(error);
    }
  };

  const handleEligibilityCheck = async () => {
    console.log("Eligibility Check Started...");

    const data = {
      patientId: info?.patientId?._id,
      agencyId: info?.agencyId?._id,
      data: {
        controlNumber: "123456789",
        tradingPartnerServiceId: "CMSMED",
        provider: {
          organizationName: "provider_name",
          npi: "0123456789",
          serviceProviderNumber: "54321",
          providerCode: "AD",
          referenceIdentification: "54321g",
        },
        subscriber: {
          memberId: "0000000000",
          firstName: "johnOne",
          lastName: "doeOne",
          gender: "M",
          dateOfBirth: "18800102",
          ssn: "555443333",
          idCard: "card123",
        },
        dependents: [
          {
            firstName: "janeOne",
            lastName: "doeone",
            gender: "F",
            dateOfBirth: "18160421",
            groupNumber: "1111111111",
          },
        ],
        encounter: {
          beginningDateOfService: "20100101",
          endDateOfService: "20100102",
          serviceTypeCodes: ["98"],
        },
      },
    };
    console.log(data, "datat==-=-=-=-");
    try {
      const response = await FetchEligibilityCheck(data);
      console.log(response, "Eligibility Check Response======");

      if (response.data?.data?.data?.errors?.length > 0) {
        const errors = response.data.data.data.errors.map(
          (error) => error.description
        );
        setErrorMessages(errors);
        setModalVisible(true);
      } else {
        setErrorMessages([]);
        setModalVisible(false);
        // alert("Your Form has been submitted, please wait for a while");
        setmodal(true);
      }
    } catch (error) {
      console.log(error, "Eligibility Check Error======");
    }
  };

  const imagePicker = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("images", file);
      try {
        const response = await uploadImage(formData);
        const url = response.data.data[0].URL;
        setImages(url);
        setValue("frontcard", url);
        trigger("frontcard");
      } catch (error) {
        console.log(error);
      }
    }
  };
  const backimagePicker = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("images", file);
      try {
        const response = await uploadImage(formData);
        const url = response.data.data[0].URL;
        setsetbackimage(url);
        setValue("backcard", url);
        trigger("backcard");
      } catch (error) {
        console.log(error);
      }
    }
  };
  return (
    <>
     <button
        type="button"
        className="add-button_insuranceDetails"
        onClick={() => setmodalopen(true)}
      >
        Add New Insurance
      </button> 
      {modalopen && (
        <div className="modal-overlay">
          <div className="modal_insuranceDetails">
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-end",
              }}
            >
              <div
                style={{
                  fontSize: "20px",
                  cursor: "pointer",
                  width: 50,
                }}
                onClick={closemodal}
              >
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTkP8S8v6oIxwDrJfdNdFU7FvVNZCcK025zZg&s"
                  style={{ height: 20, width: 20 }}
                />
              </div>
            </div>
            <h2>Insurance Details</h2>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(onSubmit, onError)(e);
              }}
            >
              <div className="form-row_insuranceDetails">
                <div className="form-column_insuranceDetails">
                  <label htmlFor="plan-type">Plan Type [Box 1]*</label>
                  <select id="plan-type" required {...register("PlanType")}>
                    <option value="">Select Option</option>
                    <option value="HMO">HMO</option>
                    <option value="PPO">PPO</option>
                    <option value="EPO">EPO</option>
                  </select>
                  <p className="error-message">{errors.PlanType?.message}</p>
                </div>
                <div className="form-column_insuranceDetails">
                  <label htmlFor="plan-name">Plan Name [Box 11c]*</label>
                  <select id="plan-name" required {...register("PlanName")}>
                    <option value="">Select Option</option>
                    {insurance.map((item) => (
                      <option
                        key={item._id}
                        value={item.adminInsurenceId?.PayerName}
                      >
                        {item.adminInsurenceId?.PayerName}
                      </option>
                    ))}
                  </select>
                  <p className="error-message">{errors.PlanName?.message}</p>
                </div>
                <div className="form-column_insuranceDetails">
                  <label htmlFor="policy-number">Policy Number [Box 1a]*</label>
                  <input
                    type="text"
                    id="PolicyNumber"
                    placeholder="Enter Policy Number"
                    required
                    {...register("PolicyNumber")}
                  />
                  <p className="error-message">
                    {errors.PolicyNumber?.message}
                  </p>
                </div>
              </div>
              <div className="form-row_insuranceDetails">
                <div className="form-column_insuranceDetails">
                  <label htmlFor="phone-number">Phone Number</label>
                  <input
                    type="text"
                    id="phone-number"
                    placeholder="(000) 000-0000"
                    {...register("PhoneNumber")}
                  />
                  <p className="error-message">{errors.PhoneNumber?.message}</p>
                </div>
                <div className="form-column_insuranceDetails">
                  <label htmlFor="group-number">Group Number [Box 11]</label>
                  <input
                    type="text"
                    id="group-number"
                    placeholder="Enter Group Number"
                    {...register("GroupNumber")}
                  />
                  <p className="error-message">{errors.GroupNumber?.message}</p>
                </div>
                <div className="form-column_insuranceDetails">
                  <label htmlFor="copay-amount">Copay Amount</label>
                  <input
                    type="text"
                    id="copay-amount"
                    placeholder="$0.00"
                    {...register("CopayAmount")}
                  />
                  <p className="error-message">{errors.CopayAmount?.message}</p>
                </div>
                <div className="form-column_insuranceDetails">
                  <label htmlFor="deductible-amount">Deductible Amount</label>
                  <input
                    type="text"
                    id="deductible-amount"
                    placeholder="$0.00"
                    {...register("DeductibleAmount")}
                  />
                  <p className="error-message">
                    {errors.DeductibleAmount?.message}
                  </p>
                </div>
              </div>
              <div className="form-row_insuranceDetails">
                <div className="form-column_insuranceDetails full-width">
                  <label htmlFor="relationship">
                    Patient's Relationship [Box 6]
                  </label>
                  <select
                    id="relationship"
                    required
                    {...register("PatientRelationship")}
                    onChange={(e) => setRelationship(e.target.value)}
                  >
                    <option value="">Select Option</option>
                    <option value="Self">Self</option>
                    <option value="Spouse">Spouse</option>
                    <option value="Child">Child</option>
                    <option value="Other">Other</option>
                  </select>
                  <p className="error-message">
                    {errors.PatientRelationship?.message}
                  </p>
                </div>
              </div>

              <div style={{ marginBottom: 20 }}>
                <label>Front of insurance card</label>
                <div
                  style={{
                    border: "1px solid #ccc",
                    width: "100%",
                    height: 46,
                    borderRadius: 5,
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: 10,
                    paddingRight: 10,
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      frontImageInputRef.current?.click();
                    }}
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: 5,
                      backgroundColor: "#fff",
                      color: "#333",
                      fontSize: 14,
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                      cursor: "pointer",
                      height: 30,
                      maxWidth: 100,
                      marginBottom: 13,
                    }}
                  >
                    Choose File
                  </button>
                  <input
                    type="file"
                    accept="image/*"
                    ref={frontImageInputRef}
                    onChange={imagePicker}
                    style={{ display: "none" }}
                  />
                  <span style={{ marginLeft: 10, fontSize: 14, color: "#666" }}>
                    {image ? "Image Uploaded" : "No file chosen"}
                  </span>
                </div>
                <input type="hidden" {...register("frontcard")} />
                <p className="error-message">{errors.frontcard?.message}</p>
              </div>

              {/* BACK CARD UPLOAD */}
              <div style={{ marginBottom: 20 }}>
                <label>Back of insurance card</label>
                <div
                  style={{
                    border: "1px solid #ccc",
                    width: "100%",
                    height: 46,
                    borderRadius: 5,
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: 10,
                    paddingRight: 10,
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      backImageInputRef.current?.click();
                    }}
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: 5,
                      backgroundColor: "#fff",
                      color: "#333",
                      fontSize: 14,
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                      cursor: "pointer",
                      height: 30,
                      maxWidth: 100,
                      marginBottom: 13,
                    }}
                  >
                    Choose File
                  </button>
                  <input
                    type="file"
                    accept="image/*"
                    ref={backImageInputRef}
                    onChange={backimagePicker}
                    style={{ display: "none" }}
                  />
                  <span style={{ marginLeft: 10, fontSize: 14, color: "#666" }}>
                    {setbackimage ? "Image Uploaded" : "No file chosen"}
                  </span>
                </div>
                <input type="hidden" {...register("backcard")} />
                <p className="error-message">{errors.backcard?.message}</p>
              </div>
              <div
                className="policy-holder_insuranceDetails"
                style={{
                  display:
                    relationship !== "Self" && relationship !== ""
                      ? "block"
                      : "none",
                }}
              >
                <h3>Policy Holder Information</h3>
                <div className="form-row_insuranceDetails">
                  <div className="form-column_insuranceDetails">
                    <label htmlFor="insured-name">Insured Name [Box 4]</label>
                    <input
                      type="text"
                      id="insured-name"
                      placeholder="Full Name"
                      {...register("insured_name")}
                    />
                    <p className="error-message">
                      {errors.insured_name?.message}
                    </p>
                  </div>
                  <div className="form-column_insuranceDetails">
                    <label htmlFor="insured-id">
                      Insured ID Number [Box 1a]
                    </label>
                    <input
                      type="text"
                      id="insured-id"
                      placeholder="ID Number"
                      {...register("insured_id")}
                    />
                    <p className="error-message">
                      {errors.insured_id?.message}
                    </p>
                  </div>
                  <div className="form-column_insuranceDetails">
                    <label htmlFor="street-address">
                      Street Address [Box 7]
                    </label>
                    <input
                      type="text"
                      id="street-address"
                      placeholder="123 Main St"
                      {...register("streetAddress")}
                    />
                    <p className="error-message">
                      {errors.StreetAddress?.message}
                    </p>
                  </div>
                </div>
                <div className="form-row_insuranceDetails">
                  <div className="form-column_insuranceDetails">
                    <label htmlFor="city">City [Box 7]</label>
                    <input
                      type="text"
                      id="city"
                      placeholder="City"
                      {...register("city")}
                    />
                    <p className="error-message">{errors.City?.message}</p>
                  </div>
                  <div className="form-column_insuranceDetails">
                    <label htmlFor="state">State [Box 7]</label>
                    <input
                      type="text"
                      id="state"
                      placeholder="State"
                      {...register("state")}
                    />
                    <p className="error-message">{errors.state?.message}</p>
                  </div>
                  <div className="form-column_insuranceDetails">
                    <label htmlFor="zip-code">Zip Code [Box 7]</label>
                    <input
                      type="text"
                      id="zip-code"
                      placeholder="12345"
                      {...register("zipCode")}
                    />
                    <p className="error-message">{errors.ZipCode?.message}</p>
                  </div>
                  <div className="form-column_insuranceDetails">
                    <label htmlFor="dob">Date of Birth [Box 3]</label>
                    <input type="date" id="dob" {...register("dob")} />
                    <p className="error-message">{errors.dob?.message}</p>
                  </div>
                </div>
              </div>
              <div className="form-buttons">
                <button type="submit" className="check-eligibility">
                  Save
                </button>
                <button type="button" className="check-eligibility">
                  Check Eligibility
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="insurance-list">
        <h2>Insurance List</h2>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Plan Type</th>
                <th>Plan Name</th>
                <th>Policy Number</th>
                <th>Phone Number</th>
                <th>Group Number</th>
                <th>Copay</th>
                <th>Deductible</th>
                <th>Relationship</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody id="insurance-table-body">
              {insurancedata.map((item) => (
                <tr key={item._id}>
                  <td>{item.PlanType}</td>
                  <td>{item.PlanName}</td>
                  <td>{item.PolicyNumber}</td>
                  <td>{item.PhoneNumber}</td>
                  <td>{item.GroupNumber}</td>
                  <td>{item.CopayAmount}</td>
                  <td>{item.DeductibleAmount}</td>
                  <td>{item.PatientRelationship}</td>
                  <td>
                    <button
                      type="button"
                      className="check-eligibility_insuranceDetails"
                      onClick={handleEligibilityCheck}
                    >
                      Check Eligibility
                    </button>
                    {/* <button
                      type="button"
                      className="action-button_insuranceDetails delete"
                      onClick={() => handleRemove(item._id)}
                    >
                      Delete
                    </button>
                    <button
                      type="button"
                      className="action-button_insuranceDetails"
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </button> */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {modalVisible && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Errors</h3>
            <ul>
              {errorMessages.map((error, index) => (
                <li key={index} className="error-message">
                  {error}
                </li>
              ))}
            </ul>
            <button
              type="button"
              className="close-error-modal"
              onClick={() => setModalVisible(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
      {modal && (
        <div className="modal_private_pay">
          <div className="modal-content_private_pay">
            <span className="close_private_pay" onClick={() => setmodal(false)}>
              ×
            </span>
            <div className="modal-title">Eligibility Check Submitted</div>
            <div className="modal-text">
              Your eligibility request has been submitted. Please wait a moment
              while we verify coverage.
            </div>
            <div className="modal-button-container">
              <button
                type="button"
                className="add-button_private_pay"
                onClick={() => setmodal(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      {confirmdeletemodal && (
        <DeleteModal
          name="Insurance"
          onClose={() => setconfirmdeletemodal(false)}
          onConfirm={confirmDelete}
        />
      )}
    </>
  );
};
const modalStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100vh",
  // backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const modalContentStyle = {
  backgroundColor: "white",
  padding: "20px",
  borderRadius: "10px",
  textAlign: "center",
};
export default InsuranceDetailsVerify;
